import * as React from "react"
import { cn } from "./lib/cn"
import type { LucideIcon } from "lucide-react"
import { AmbientBlobs } from "./ambient-blobs"

function GlassEmptyState({
  icon: Icon,
  title,
  description,
  className,
  children,
  ...props
}: React.ComponentProps<"div"> & {
  icon: LucideIcon
  title: string
  description: string
}) {
  return (
    <div
      data-slot="glass-empty-state"
      className={cn(
        "relative flex flex-col items-center justify-center py-16 text-center",
        "rounded-xl backdrop-blur-xs bg-white/50 border border-white/30",
        "dark:bg-white/6 dark:border-white/10",
        className
      )}
      {...props}
    >
      <AmbientBlobs />
      <div className="relative z-10 flex flex-col items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-cova-brand/10 dark:bg-cova-brand/20">
          <Icon className="h-6 w-6 text-cova-brand dark:text-cova-brand/80" />
        </div>
        <h3 className="text-sm font-semibold text-gray-900 dark:text-white">{title}</h3>
        <p className="text-sm text-gray-500 max-w-xs dark:text-gray-400">{description}</p>
        {children}
      </div>
    </div>
  )
}

export { GlassEmptyState }
